<script setup lang="ts">
import AuSkeletonWrapper from '~/components/ui/AuSkeletonWrapper.vue'
import AuSkeleton from '~/components/ui/AuSkeleton.vue'
</script>

<template>
  <AuSkeletonWrapper>
    <div class="mb-8 flex items-center justify-between">
      <AuSkeleton
        height="30px"
        border-radius="4px"
        width="50%"
        background="var(--theme-20)"
      />
      <div class="flex items-center gap-4">
        <AuSkeleton
          height="40px"
          border-radius="4px"
          width="90px"
          background="var(--theme-20)"
        />
        <AuSkeleton
          height="40px"
          border-radius="4px"
          width="90px"
          background="var(--theme-20)"
        />
      </div>
    </div>
    <ul class="flex flex-col gap-5">
      <li v-for="i in 4" :key="i">
        <div class="space-y-1">
          <AuSkeleton
            height="30px"
            border-radius="4px"
            width="40%"
            background="var(--theme-20)"
          />
          <AuSkeleton
            border-radius="4px"
            height="70px"
            background="var(--theme-20)"
          />
        </div>
      </li>
    </ul>
  </AuSkeletonWrapper>
</template>
